<template>
  <el-dialog
    class="modal-modify-takeawaySys"
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    lock-scroll
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="content">
      <el-form
        ref="modify"
        :rules="rules"
        v-loading="isLoading"
        label-position="right"
        :model="formData"
        class="platform-modify__form"
      >
        <el-form-item label="定制系统:">
          <el-input
            :disabled="true"
            v-model="formData.sysName"
            placeholder="必选"
            style="width: 291px;"
          ></el-input>
          <el-button v-if="formType !== 'edit'" @click="$_selectSys" class="select__btn">选择</el-button>
        </el-form-item>

        <el-form-item label="定制系统应用:" prop="sysAppName">
          <el-input
            v-model="formData.sysAppName"
            :disabled="formType === 'edit'"
            placeholder="必填"
            style="width: 291px;"
          ></el-input>
          <div
            class="input-tips"
          >*仅支持16个中文字符或32个英文字符,并只包含.。，,()（）【】[]、\_-— 以上字符，</div>
        </el-form-item>

        <el-form-item label="授权URL:" prop="authUrl">
          <el-input v-model="formData.authUrl" placeholder="选填" style="width: 291px;"></el-input>
        </el-form-item>

        <div v-if="formData.isSysConfig">
					<el-form-item label="系统级参数:"></el-form-item>
          <el-form-item
            v-for="(item, index) in configInfos[formData.sysType]"
            :key="index"
            :label="item.name + ':'"
            :required="item.required"
          >
            <el-input v-model="item.value" style="width: 291px;" :placeholder="item.required ? '必填' : '非必填'"></el-input>
            <div class="input-tips">{{item.memo}}</div>
          </el-form-item>
        </div>

        <el-form-item label="备注:" prop="memo" type="textarea">
          <el-input
            type="textarea"
            v-model="formData.memo"
            style="width: 366px; height: 100px;"
            resize="none"
            placeholder="选填"
          ></el-input>
          <div class="input-tips">*最多支持50个字符</div>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button class="save__btn" @click="$_submit">保存</el-button>
      <el-button class="cancel__btn" @click="$_cancle">取消</el-button>
    </div>
    <!-- 选择外卖平台弹窗组件 -->
    <select-sys
      v-if="modal.show === true && modal.template === 'select-sys'"
      :title="modal.title"
      :selected="modal.data"
      @callback="$_callbackSys"
      @close="$_close"
      :sysConfig="true"
    ></select-sys>
  </el-dialog>
</template>
<script>
import * as Utils from "@/plugins/utils";
import SelectSys from "./modal-select-takeawayCompany";

export default {
  name: "modal-modify-takeawaySys",
  props: {
    title: { type: String, default: "" },
    formType: { type: String, default: "add" },
    modalData: { type: Object, default: {} }
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      formData: {
        sysConfigId: -1,
        sysType: "",
        sysName: "",
        sysAppName: "",
        authUrl:"",
        isSysConfig: false,
        // sysConfigMap: {},
        memo: ""
      },
      configInfos: {},
      modal: {
        show: false,
        title: "",
        template: "",
        data: {}
      },
      rules: {
        sysName: [{ required: true, message: "请选择定制系统" }],
        sysAppName: [
          { required: true, message: "请输入定制系统应用" },
          {
            validator: (rule, value, callback) => {
              let length = Utils.getStrLength(value);
              if (value && length > 32) {
                callback(new Error("长度为16个中文字符或32个数字英文字符"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          },
          { validator: Utils.validCharmap, trigger: "blur" }
        ],
        memo: [
          {
            validator: (rule, value, callback) => {
              if (value !== "" && value.length > 50) {
                callback(new Error("最多50个字符!"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          },
        ]
      }
    };
  },
  methods: {
    // 选择外卖平台
    $_selectSys() {
      this.modal.data = {
        sysType: this.formData.sysType,
        sysName: this.formData.sysName,
      };
      this.modal.title = "选择定制平台";
      this.modal.template = "select-sys";
      this.modal.show = true;
    },
    // 选择外卖平台回调
    $_callbackSys(data) {
      let { sysType, sysName, sysConfig, sysConfigFields,serviceType } = data;
      this.formData.sysType = sysType;
      this.formData.sysName = sysName;
      this.formData.isSysConfig = sysConfig;
       this.formData.serviceType = serviceType;
      if (sysConfig === true) {
        if (!this.configInfos.hasOwnProperty(sysType)) {
          let configs = [];
          sysConfigFields.forEach(item => {
            configs.push({
              required: item.required,
              name: item.name,
              memo: item.memo,
              value: ""
            });
          });
          this.$set(this.configInfos, sysType, configs);
          // this.configInfos[sysType] = configs;
        }
      }
    },
    // 关闭选择品牌
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.title = "";
      this.modal.data = {};
    },
    $_submit() {
			if (this.formData.sysType === "") {
				$MessageBox.alert({content: '请选择所属定制系统'});
				return false;
			}
      this.$refs["modify"].validate(valid => {
        if (valid) {
          let {
            sysConfigId,
            sysType,
            sysAppName,
            memo,
            authUrl,
            serviceType
          } = this.formData;

          let sysConfigMap = {};
          if (this.formData.isSysConfig === true) {
            for (const item of this.configInfos[sysType]) {
              if (item.required == true && item.value == "") {
                $MessageBox.alert({
                  content: `系统级参数 ${item.name} 不能为空, 请填写!`
                });
                return false;
              }
              Object.assign(sysConfigMap, { [item.name]: item.value });
            }
          }

          const self = this;
          self.isLoading = true;
          let action = "addCustomSysConfig";

          let postData = {
            sysType,
            sysAppName,
            sysConfigMap,
            memo,
            authUrl,
            serviceType
          };
          if (self.formType === "edit") {
            action = "editCustomSysConfig";
            Object.assign(postData, { sysConfigId });
          }

          self.$service.post(action, postData).then(result => {
            self.isLoading = false;
            if (result.$.checkResult(result, true)) {
              $MessageBox.alert({
                content: result.msg,
                onOk() {
                  self.visible = false;
                  self.$emit("callback");
                }
              });
            }
          });
        }
      });
    },

    $_cancle() {
      this.visible = false;
      this.$emit("close");
    }
  },
  created() {
    if (this.formType === "edit") {
      let {
        sysConfigId,
        sysType,
        sysName,
        authUrl,
        sysAppName,
        sysConfigMap,
        sysConfigFields,
        memo,
        serviceType
      } = this.modalData;
      // 有系统级参数配置时需要作处理
       if (
        typeof sysConfigFields !== "undefined" &&
        Object.keys(sysConfigFields).length > 0
      ) {
        this.formData.isSysConfig = true;
        let configs = [];
        sysConfigFields.forEach(key => {
          configs.push({
            required: key.required,
            name: key.name,
            memo: key.memo,
            value: sysConfigMap[key.name]
          });
        });
        this.$set(this.configInfos, sysType, configs);
      }

      this.formData.sysConfigId = sysConfigId;
      this.formData.sysType = sysType;
      this.formData.sysName = sysName;
      this.formData.sysAppName = sysAppName;
      this.formData.memo = memo;
      this.formData.authUrl = authUrl;
       this.formData.serviceType = serviceType;
    }
  },
  mounted() {
    this.visible = true;
  },
  components: {
    SelectSys
  }
};
</script>

<style lang="scss" scoped>
.platform-modify__form {
  padding: {
    left: 20px;
  }
}
.content {
  padding: 20px 20px;
  .title {
    height: 32px;
    color: #384e8c;
    font-size: 14px;
    font-weight: 700;
  }
}
.select__btn {
  margin-left: 8px;
  vertical-align: top;
}
.type__chk {
  margin: {
    top: 5px;
    right: 64px;
  }
}
.input-tips{
  margin-left:10px;
}
</style>


